// extracted by mini-css-extract-plugin
export default {"path":"CircleIcon_path__eOr2Q"};